import React, { useContext } from "react";
import {
    TitleWrapper,
    TitleText,
    StyledButton,
} from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";
import { TitleBar } from "../../../configs/accountingAccount";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = [ROLE.MANAGER, ROLE.ACCOUNTANT_MANAGER].includes(role);

    const onClickAddButton = () => {
        navigate("/accounting-accounts/create");
    };

    return (
        <TitleWrapper>
            <TitleText data-testid="page-title">{TitleBar.title}</TitleText>
            {canCreate && (
                <StyledButton
                    data-testid="create-accounting-account-button"
                    variant="contained"
                    onClick={onClickAddButton}
                >
                    <AddIcon />
                    {TitleBar.addButtonText}
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
